<template>
  <BaseLoading  opaque :spinning="loading">
    <div class="page-wrapper profile-list-page">
      <div class="container">
        <div class="top-wrap">
          <div class="page-heading">
            <h1 class="page-title">My Profiles</h1>
            <router-link
              to="/new/create-profile"
              v-if="!isIncomplete && !isFree"
            >
              <a-button v-if="!isAdminUser()" type="primary" icon="plus">Add New Profile</a-button>
            </router-link>
          </div>
          <a-alert
            class="margin-bottom-1"
            message="Please complete the latest player profile to create new one!"
            type="info"
            show-icon
            v-if="isIncomplete"
          />
          <a-alert
            class="margin-bottom-1"
            message="Please upgrade the free version to paid to add new profile!"
            type="info"
            show-icon
            v-if="isFree"
          />
          <a-alert
            class="margin-bottom-1"
            message="Let’s Get Started! Create your detailed profile now by clicking the “Add New Profile Button”"
            type="info"
            show-icon
            closable
            v-if="_.isEmpty(data)"
          />
          <a-alert type="info" show-icon closable v-if="_.isEmpty(data)">
            <span slot="message">
              In the payment step of your profile creation, you can take
              advantage of all our PREMIUM features by selecting our
              {{
                paymentPlans.find(item => item.price === 0) &&
                  paymentPlans.find(item => item.price === 0).duration
              }}-day FREE TRIAL or you can secure all your PREMIUM features by
              selecting a plan of your choice.</span
            ></a-alert
          >
        </div>
        <a-table :columns="columns" :data-source="data" :scroll="{ x: 575 }">
          <span slot="player" slot-scope="name, record">
            <router-link
              :to="`/create-profile/${record.key}`"
              v-if="record.profileType === 'Incomplete'"
            >
              <a>{{ name }}</a>
            </router-link>
            <router-link
              :to="`/${record.key}/athelete/summary?key=profile-list-player`"
              v-else
            >
              <a>{{ name }}</a>
            </router-link>
          </span>
          <span slot="profileType" slot-scope="type">
            <a-tag
              :color="
                type === 'Incomplete'
                  ? 'volcano'
                  : type === 'Free'
                  ? 'geekblue'
                  : 'green'
              "
              >{{ type.toUpperCase() }}</a-tag
            >
          </span>
          <span slot="action" slot-scope="action, record">
            <router-link
              :to="{
                path: `/${record.key}/transaction-history`,
                query: { name: record.player }
              }"
            >
              <a
                class="transaction-link"
                @click="handleRouterClick(record.profileType)"
                >Transaction History</a
              >
            </router-link>
            <a-divider type="vertical" />
            <a @click="handleUpgradeButtonClick(record.key, record.player)">
              {{ action.action }}
            </a>
          </span>
        </a-table>
        <a-drawer
          class="update-drawer"
          :title="`Upgrade Payment for ${upgradedPlayer}`"
          :width="520"
          :visible="showUpgradeDrawer"
          :body-style="{ padding: '20px' }"
          @close="() => this.handleUpgradeButtonClick('', '')"
        >
          <PaymentShow
            v-if="upgradeKey"
            :id="upgradeKey"
            :upgradedPlayer="upgradedPlayer"
            @close-drawer="afterPaymentComplete"
          />
        </a-drawer>
      </div>
    </div>
  </BaseLoading>
</template>
<script>
const PAYMENT_STORE_KEY = "paymentStore";
const columns = [
  {
    title: "Player",
    key: "player",
    dataIndex: "player",
    scopedSlots: { customRender: "player" }
  },
  {
    title: "Profile Type",
    dataIndex: "profileType",
    key: "profileType",
    scopedSlots: { customRender: "profileType" }
  },
  {
    title: "Last Pricing Plan",
    dataIndex: "pricingPlan",
    key: "pricingPlan"
  },
  {
    title: "Last Payment Date",
    dataIndex: "lastPaymentDate",
    key: "lastPaymentDate"
  },
  {
    title: "Expiration Date",
    dataIndex: "expiryDate",
    key: "expiryDate"
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];

import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";
import PaymentShow from "./payment-upgrade";
const STORE_KEY = "playerStore";
const AthleteRepository = RepositoryFactory.get("athlete");

export default {
  name: "ProfileList",
  data() {
    return {
      data: [],
      isIncomplete: false,
      isFree: false,
      columns,
      showUpgradeDrawer: false,
      upgradeKey: "",
      upgradedPlayer: ""
    };
  },
  components: {
    PaymentShow
  },
  mounted() {
    this.setProfileList();
    this.$store.dispatch(`${PAYMENT_STORE_KEY}/getPaymentPlans`);
    this.chatSockets.clearEvents();
    this.chatSockets.addEvents([
      { name: "userForceLogout", handler: this.logOut },
    ]);
  },
  watch: {
    // whenever changes, this function will run
    ProfileList: function(newList) {
      let array = newList.map(data => ({
        key: data.id,
        player: data.athletename,
        profileType: data.profileType,
        pricingPlan:
          (data["lastPlanId"] &&
            data["lastPlanId"]["duration"] &&
            `${Number(data["lastPlanId"]["duration"]) / 30} Months`) ||
          "none",
        lastPaymentDate: data.lastPaymentDate
          ? new Date(data.lastPaymentDate).toLocaleString()
          : "none",
        expiryDate: data.expiryDate
          ? new Date(data.expiryDate).toLocaleString()
          : "none",
        action: data.action
          ? data.action
          : data.profileType === "Paid" ||
            data.profileType === "Free" ||
            data.profileType === "Basic"
          ? "Upgrade"
          : ""
      }));
      let incomplete = array.filter(arr => arr.profileType === "Incomplete");
      let free = array.filter(arr => arr.profileType === "Free");
      if (incomplete.length > 0) {
        this.isIncomplete = true;
      } else if (free.length > 0) {
        this.isFree = true;
      } else {
        this.isIncomplete = false;
        this.isFree = false;
      }
      this.data = array;
    }
  },
  computed: {
    ...mapGetters({
      ProfileList: `${STORE_KEY}/getProfileList`,
      loading: `${STORE_KEY}/loading`,
      paymentPlans: `${PAYMENT_STORE_KEY}/paymentPlans`
    })
  },
  methods: {
    isAdminUser(){
      return localStorage.getItem('profile-type') === 'AdminUser';
    },
    handleRouterClick(type) {
      localStorage.setItem("profile-type", type);
    },
    logOut(msg){
      let logged_by = msg.logoutType;
      let logged_msg = msg.message;
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('logged_by', logged_by)
      localStorage.setItem('logged_msg', logged_msg);
      this.chatSockets.tearDownConnection();
      window.location.href = "/login";
    },
    ...mapActions({
      setProfileList: `${STORE_KEY}/setProfileList`
    }),
    afterPaymentComplete() {
      this.handleUpgradeButtonClick("", "");
      this.setProfileList();
    },
    handleUpgradeButtonClick(key, name) {
      this.upgradeKey = key;
      this.upgradedPlayer = name;
      this.showUpgradeDrawer = !this.showUpgradeDrawer;
    },
    removeProfile(id) {
      AthleteRepository.deleteProfile(id).then(response => {
        this.$message.success("Profile Deleted");
        this.setProfileList();
      });
    }
  }
};
</script>

<style lang="scss">
.page-wrapper {
  padding: 40px 0;
}
.profile-list-page {
  .top-wrap {
    margin-bottom: 40px;
    .page-heading {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .ant-form-item-control {
        text-align: center;
      }
      .ant-btn-primary {
        background: #293187;
        border-color: #293187;
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .update-drawer {
    .ant-drawer-content-wrapper {
      width: 100% !important;
    }
    .general-form-wrap {
      .heading {
        justify-content: center !important;
      }
    }
    .payment-form-wrap {
      .add-payment-container {
        padding: 20px 10px;
      }
    }
  }
}
</style>
